import Vue from 'vue';
import { ethers } from 'ethers';
import IO from '@/contracts/IO.json';
import addresses from '@/contracts/addresses.json';

const state = {
  iOAbi: null,
  iOAddress: null,
  iOContract: null,
  iOContractData: { hasPopulated: false },
  isNewDAInterval: false,
  daData: {
    price: 1.5,
    currentTime: 0,
  },
};

const getters = {
  getIOAbi(state) {
    return state.iOAbi;
  },
  getIOAddress(state) {
    return state.iOAddress;
  },
  getIOContract(state) {
    return state.iOContract;
  },
  getIOContractData(state) {
    return state.iOContractData;
  },
  getIsNewDAInterval(state) {
    return state.isNewDAInterval;
  },
  getDAData(state) {
    return state.daData;
  },
};

const actions = {
  storeIOAbi({ commit }) {
    commit('setIOAbi', IO.abi);
  },
  storeIOAddress({ commit, rootState }) {
    let chainIdDec = parseInt(rootState.accounts.chainId);
    if (isNaN(chainIdDec)) {
      // Set chainId based on app env - rinkey for staging
      chainIdDec = process.env.VUE_APP_ENV === 'production' ? '0x1' : '0x4';
    }

    let iOAddress = addresses.IO[chainIdDec];

    commit('setIOAddress', iOAddress);
  },
  loadIOContract({ state, commit, rootGetters }) {
    Vue.set(state.iOContractData, 'hasPopulated', false);

    const signer = rootGetters['accounts/getProviderEthers'].getSigner();

    const contract = new ethers.Contract(state.iOAddress, state.iOAbi, signer);

    // Set up events
    contract.on('Minted', async (remainingSupply) => {
      Vue.set(state.iOContractData, 'remainingSupply', remainingSupply);
    });

    commit('setIOContract', contract);
  },
  async storeDAData({ state, commit }) {
    const daData = await state.iOContract.getDAData();
    commit('setDAData', daData);
  },
};

const mutations = {
  setIOAbi(state, abi) {
    state.iOAbi = abi;
  },
  setIOAddress(state, address) {
    state.iOAddress = address;
  },
  setIOContract(state, contract) {
    Vue.set(state, 'iOContract', contract);
  },
  setIOContractData(state, contractData) {
    Vue.set(state, 'iOContractData', contractData);
  },
  setIsNewDAInterval(state, isNewDAInterval) {
    state.isNewDAInterval = isNewDAInterval;
  },
  setDAData(state, daData) {
    Vue.set(state, 'daData', {
      price: parseFloat(ethers.utils.formatEther(daData.price.toString())),
      currentTime: daData.currentTime.toString(),
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
